const map = L.map('map', {
    zoomControl: false,
    preferCanvas: true,
});

L.control
    .zoom({
        position: 'topright',
    })
    .addTo(map);

L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
    attribution: '&copy; <a href="https://carto.com/">Carto</a>',
}).addTo(map);

const storeIcon = L.icon({
    iconUrl:
        'data:image/svg+xml;base64,' +
        btoa(`
         <svg width="20" height="20" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="25" fill="${window.accentuationColor}"/>
         </svg>
     `),
    iconSize: [20, 20],
    iconAnchor: [10, 20],
    popupAnchor: [0, -20],
});

const searchIcon = L.icon({
    iconUrl:
        'data:image/svg+xml;base64,' +
        btoa(`
          <svg width="20" height="20" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="25" cy="25" r="25" fill="#303030"/>
         </svg>
     `),
    iconSize: [20, 20],
    iconAnchor: [10, 20],
    popupAnchor: [0, -20],
});

let searchMarker = null;

const stores = window.stores;

const pointsDeVente = stores.map((store) => ({
    nom: store.nom,
    adresse: store.rue + ', ' + store.code_postal + ' (' + store.ville + ')',
    lat: store.latitude,
    lng: store.longitude,
    lien: store.lien,
}));

const bounds = L.latLngBounds(pointsDeVente.map((point) => [point.lat, point.lng]));

// Centrer la carte sur les limites de tous les points avec une marge
map.fitBounds(bounds, {
    padding: [50, 50],
});

const markers = pointsDeVente.map((point) => {
    const marker = L.marker([point.lat, point.lng], { icon: storeIcon }).addTo(map);

    const popupContent =
        (point.lien ? `<a class="hover:xtext-text-40 xtext-text-90" href="${point.lien}" target="_blank">` : '') +
        `
         <div class="xtext-center xfont-sans">
             <h3 class="xfont-medium text-button-big xpt-1">${point.nom}</h3>
             <p class="xfont-medium text-button-small">${point.adresse}</p>
         </div>
     ` +
        (point.lien ? '</a>' : '');

    marker.bindPopup(popupContent, { closeButton: false });
    return { ...point, marker };
});

function getDistance(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

function findNearestStores(lat, lng, count = 3) {
    return markers
        .map((store) => ({
            ...store,
            distance: getDistance(lat, lng, store.lat, store.lng),
        }))
        .sort((a, b) => a.distance - b.distance)
        .slice(0, count);
}

document.getElementById('search-address-form').addEventListener('submit', async (event) => {
    event.preventDefault();
    const address = document.getElementById('search-address-input').value;

    try {
        const response = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
        );
        const data = await response.json();

        if (data.length > 0) {
            const { lat, lon } = data[0];

            if (searchMarker) {
                searchMarker.remove();
            }

            searchMarker = L.marker([lat, lon], {
                icon: searchIcon,
            }).addTo(map);

            const nearestStores = findNearestStores(parseFloat(lat), parseFloat(lon));
            const nearest = nearestStores[0];

            map.fitBounds(
                [
                    [lat, lon],
                    [nearest.lat, nearest.lng],
                ],
                { padding: [50, 50] }
            );

            const resultDiv = document.getElementById('result');
            resultDiv.classList.remove('xhidden');
            resultDiv.classList.add('xgrid');
            resultDiv.innerHTML = nearestStores
                .map((store, index) => {
                    let distance = store.distance.toFixed(0);
                    if (store.distance < 10) {
                        distance = (store.distance * 1000).toFixed(0) + ' m';
                    } else {
                        distance += ' km';
                    }
                    return `
                    <li>
                        <${store.lien ? 'a' : 'div'} href="" class="xfont-medium xtext-text-90">
                            <div class="text-button-big xpb-xsl">${index + 1}.</div>
                            <address class="text-button-small xnot-italic xinline-block">
                                ${store.nom}<br>
                                ${store.adresse}<br>
                                <span class="text-button-small xtext-text-40">Distance : ${distance}</span>
                            </address>
                        </${store.lien ? 'a' : 'div'}>
                    </li>
                `;
                })
                .join('');

            nearest.marker.openPopup();
        }
    } catch (error) {
        console.error('Erreur lors de la recherche :', error);
        alert("Erreur lors de la recherche de l'adresse");
    }
});
